export default function convertCurrencyToNumber(currency: string): number {
  return parseFloat(currency.replace(/(\$|,)/g, ""))
}
